import materialUI from "material-UI";
import styled from "styled-components";
import colors from "../../../../constants/color";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const BodyContainer = styled.div`
  width: 100%;
  border: 1px solid #abbdff;
  border-radius: 8px;
  padding: 0 12px 12px 12px;
  margin-top: 24px;
  background-color: #eaefff;
`;

export const Row = styled.div`
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: row;
  padding-top: 12px;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
`;

export const TitleInfo = styled.h1`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;

  color: #2d5bff;
  word-wrap: break-word;
  white-space: normal;
  max-width: 100%;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 4px;
  label {
    display: none;
  }

  .MuiInputBase-root {
    border-radius: 8px;
    height: 44px;
    margin: 0;
    padding-top: 2px;
  }
  .MuiInputBase-input {
    height: 44px;
  }
  .MuiTypography-root {
    padding-top: 1px;
  }
  .MuiOutlinedInput-input {
    padding: 0 12px;
  }

  .MuiOutlinedInput-adornedStart {
    padding-bottom: 2px;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 4px;
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: #d5deff; /* Mantemos essa linha para consistência */
    input {
      color: ${colors.grey1};
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #d5deff !important; /* Define a cor de fundo vermelha para campos desativados */
    input {
      font-family: Inter;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;

      color: #2d5bff;
    }
    fieldset {
      border-color: #abbdff !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const Rounded = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background-color: #d5deff;
  border-radius: 50%;
  cursor: pointer;
  text-decoration: none;
  border: none;
`;

export const Overlay = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  height: 92%;
  background-color: #d5deff;
  border: 1px solid #abbdff;
  border-radius: 8px;
  padding: 11px;
`;

export const OverlayInfo = styled.div`
  background-color: #abbdff;
  border-radius: 4px;
  height: 20px;
`;
